export enum CacheKeys {
    ZipcodesRange = 'zipcodes-range'
}